var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"transition":"fade-transition"}},[_c('div',{staticClass:"mx-auto pt-10",staticStyle:{"max-width":"200px"}},[_c('Cover',{attrs:{"src":_vm.item.cover}}),_c('v-progress-linear',{attrs:{"indeterminate":""}}),_c('p',{staticClass:"text-h5 mt-2"},[_vm._v(" "+_vm._s(_vm.item.title)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }